import { useState } from 'react';
import { Box, ButtonBase, makeStyles } from '@material-ui/core';
import { DropDownIcon, DropUpIcon } from '../../../../components/Icon';
import StatusBar from '../../EmergencyAdmission/StatusBar';

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: '#FFFFFF',
    padding: '0.3rem 0.5rem',
  },
  detailBtn: ({ detailOpen }) => ({
    fontFamily: 'NotoSans-Medium',
    color: detailOpen ? '#7d86a9' : '#fff',
    fontSize: '0.9rem',
    width: '11.25rem',
    minWidth: '11.25rem',
    height: '1.7rem',
    border: 'solid 1px #e4e7eb',
    borderRadius: '4px',
    backgroundColor: detailOpen ? '#fff' : '#7d86a9',
  }),
  dropIcon: {
    fontSize: '0.875rem',
    marginLeft: '1rem',
  },
}));

// 显示Location View共用的Statistic Detail。
export default function StatisticDetail({ data }) {
  const [detailOpen, setDetailOpen] = useState(false);
  const classes = useStyles({ detailOpen });

  return (
    <Box className={classes.root}>
      {detailOpen && (
        <Box mb="0.7rem">
          <StatusBar data={data} />
        </Box>
      )}
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <ButtonBase className={classes.detailBtn} onClick={() => setDetailOpen((open) => !open)}>
          Statistic Detail
          {detailOpen ? <DropUpIcon className={classes.dropIcon} /> : <DropDownIcon className={classes.dropIcon} />}
        </ButtonBase>
        <Box width="100%" height="1px" bgcolor="#ddd" />
      </Box>
    </Box>
  );
}
